export default __webpack_public_path__ + "static/media/patrat.aeec33e4.png";